module.exports = __webpack_public_path__ + "e8de1a13b1e2e0d6c40b6ddcab41aed8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/settings/orderonline2.png
// module id = 707
// module chunks = 0